import React, { PureComponent } from 'react';
import {
	Form,
	Input,
	Submit,
	SearchIcon
} from './ampSearchStyles';

class AmpSearchBar extends PureComponent {
	render () {
		return (
			<Form
				action="/search"
				method="GET"
				target="_top"
			>
				<Input
					type="search"
					name="q"
					placeholder="Find a box you'll love..."
				/>

				<Submit type="submit" title="Search subscription boxes">
					<SearchIcon />
				</Submit>
			</Form>
		);
	}
}

export default AmpSearchBar;
